import { ALL_STORES } from 'data/contentstack/get-product-promo';

export const selectProductPromotions = ({
  productPromotions: { promotions },
  storeSelection,
}) =>
  promotions[storeSelection.toLowerCase()] ||
  promotions[ALL_STORES.toLowerCase()] ||
  {};
